var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Upload_Icon_White"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload_Icon_White",
    "data-name": "Upload Icon White",
    clipPath: "url(#clip-Upload_Icon_White)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5524",
    "data-name": "Path 5524",
    d: "M609.062,690.662l1.522-1.522v8.051a.737.737,0,0,0,1.474,0V689.14l1.522,1.522a.737.737,0,1,0,1.046-1.04l0,0-2.781-2.781a.736.736,0,0,0-1.042,0h0l-2.781,2.781a.737.737,0,1,0,1.04,1.045l0,0Z",
    transform: "translate(-599 -684.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5525",
    "data-name": "Path 5525",
    d: "M617.711,693.013a.738.738,0,0,0-.738.737V699.4h-11.3V693.75a.737.737,0,0,0-1.474,0v5.9a1.229,1.229,0,0,0,1.229,1.229h11.8a1.229,1.229,0,0,0,1.229-1.229v-5.9A.737.737,0,0,0,617.711,693.013Z",
    transform: "translate(-599 -684.5)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.f0f445eaefc0aeb4adae34980758c49b.svg";
export { ForwardRef as ReactComponent };